module.exports = __webpack_public_path__ + "img/1707036363190-a-rain.jpg.b409bc50.webp";